<ion-content #content class="section-content-white wizard-content">
    <div class="wizard-content-inner" *ngIf="wizardPage">
        <div *ngIf="auftragdetails?.isSchreibgeschuetztAnzeigen" class="archiv-message">Schreibgeschützt<span *ngIf="auftragdetails?.schreibschutzGrund"> – {{ auftragdetails.schreibschutzGrund }}</span></div>

        <h1 *ngIf="wizardPage.Titel">{{ wizardPage.Titel }}</h1>

        <div *ngFor="let c of wizardPage.Formular.komponenten">
            <div [ngSwitch]="c.name">
                <!-- Fahrzeug-Kennzeichen -->
                <fahrzeug-kennzeichen-komponente *ngSwitchCase="'Fahrzeug-Kennzeichen'" [auftragdetails]="auftragdetails" [komponente]="c"></fahrzeug-kennzeichen-komponente>

                <!-- Abholadresse -->
                <auftrag-adresse-komponente *ngSwitchCase="'Abholadresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Abholadresse"></auftrag-adresse-komponente>

                <!-- Zweite Abholstelle. Wird nur angezeigt, wenn sie vom ERP gefüllt wurde -->
                <auftrag-adresse-komponente *ngSwitchCase="'Abholadresse2'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Abholadresse2"></auftrag-adresse-komponente>

                <!-- Erzeugeradresse -->
                <auftrag-adresse-komponente *ngSwitchCase="'Erzeugeradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Erzeugeradresse"></auftrag-adresse-komponente>

                <!-- Verwerteradresse -->
                <auftrag-adresse-komponente *ngSwitchCase="'Verwerteradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Verwerteradresse"></auftrag-adresse-komponente>

                <!-- Barcode -->
                <auftrag-barcode-komponente *ngSwitchCase="'Barcode'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-barcode-komponente>

                <!-- Lieferung -->
                <auftrag-lieferung-komponente *ngSwitchCase="'Lieferung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-komponente>

                <!-- Lieferung-Details -->
                <auftrag-lieferung-details-komponente *ngSwitchCase="'Lieferung-Details'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-details-komponente>

                <!-- Leergut -->
                <auftrag-leergut-komponente *ngSwitchCase="'Leergut'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-leergut-komponente>

                <!-- Hinweistexte -->
                <auftrag-hinweistexte-komponente *ngSwitchCase="'Hinweistexte'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-hinweistexte-komponente>

                <!-- Auftragsbilder -->
                <auftrag-bilder-komponente *ngSwitchCase="'Bilder'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder-komponente>

                <!-- Bilder (Kommissionierung) -->
                <auftrag-bilder2-komponente *ngSwitchCase="'Bilder2'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder2-komponente>

                <!-- Anmerkungen-->
                <auftrag-anmerkungen-komponente *ngSwitchCase="'Anmerkungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-anmerkungen-komponente>

                <!-- Ext. Auftragsnummer-->
                <auftrag-ext-nummer-komponente *ngSwitchCase="'Ext-Nummer'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-ext-nummer-komponente>

                <!-- Unterschrift -->
                <auftrag-unterschrift-komponente *ngSwitchCase="'Unterschrift'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-unterschrift-komponente>

                <!-- Statusmeldung -->
                <auftrag-statusmeldungen-komponente *ngSwitchCase="'Statusmeldungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-statusmeldungen-komponente>

                <!-- Checkliste -->
                <auftrag-checkliste-komponente *ngSwitchCase="'Checkliste'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-checkliste-komponente>

                <!-- Dateien -->
                <auftrag-dateien-komponente *ngSwitchCase="'Dateien'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-dateien-komponente>

                <!-- Buttons -->
                <auftrag-buttons-komponente *ngSwitchCase="'Buttons'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-buttons-komponente>

                <!-- Buttons 2 -->
                <auftrag-buttons-komponente *ngSwitchCase="'Buttons2'" [auftragdetails]="auftragdetails" [komponente]="c" [nummer]="2"></auftrag-buttons-komponente>

                <!-- Buttons 3 -->
                <auftrag-buttons-komponente *ngSwitchCase="'Buttons3'" [auftragdetails]="auftragdetails" [komponente]="c" [nummer]="3"></auftrag-buttons-komponente>

                <!-- Zeiterfassung -->
                <auftrag-zeiterfassung-komponente *ngSwitchCase="'Zeiterfassung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-zeiterfassung-komponente>

                <!-- Pellets einblasen für THEURL -->
                <auftrag-pellets-einblasen-komponente *ngSwitchCase="'PelletsEinblasen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-pellets-einblasen-komponente>

            </div>
        </div>
    </div>

    <div class="section buttons-section wizard-buttons">
        <ion-button appClick (clicked)="onZurueck()" expand="full" color="light" class="status-button button-md button3">
            {{ 'Zurück' | translate }}
        </ion-button>
        <ion-button appClick (clicked)="onMehr()" expand="full" color="light" class="status-button button-md button3" [disabled]="mehrDisabled">
            {{ '...' | translate }}
        </ion-button>
        <ion-button appClick (clicked)="onWeiter()" expand="full" color="primary" class="status-button button-md button3" *ngIf="weiterVerfuegbar">
            {{ 'Weiter' | translate }}
        </ion-button>
        <ion-button appClick (clicked)="onFertig(standardFertigStatus)" expand="full" color="success" class="status-button button-md button3" *ngIf="!weiterVerfuegbar && standardFertigStatus">
            {{ 'Fertig' | translate }}
        </ion-button>
    </div>
</ion-content>